import ArcelikLogo from '../assets/img/logo/arcelik.png'
import ArcelikGlobalLogo from '../assets/img/arcelik-global-logo.png';
import ArcelikBoxIcon from '../assets/img/boxIcon-arcelik.svg'
import ArcelikRegisterIcon from '../assets/img/registerIcon-arcelik.svg'
import ArcelikBookIcon from '../assets/img/bookIcon-arcelik.svg'
import ArcelikGlobalFavicon from '../assets/img/arcelikglobal-favicon.png';
import ArcelikFavicon from '../assets/img/arcelik-favicon.ico';
import BekoLogo from '../assets/img/beko_logo.png'
import BekoBoxIcon from '../assets/img/boxIcon.png';
import BekoBookIcon from '../assets/img/bookIcon.png'
import BekoRegisterIcon from '../assets/img/registerIcon.png'
import BekoFavicon from '../assets/img/beko-favicon.ico';
import AltusLogo from '../assets/img/altus-logo.png'
import AltusBoxIcon from '../assets/img/boxIcon-altus.png'
import AltusRegisterIcon from '../assets/img/registerIcon-altus.png'
import AltusBookIcon from '../assets/img/bookIcon-altus.png'
import AltusFavicon from '../assets/img/altus-favicon.ico';
import GrundigLogo from '../assets/img/logo/grundig.svg';
import GrundigBoxIcon from '../assets/img/boxIcon-grundig.png'
import GrundigRegisterIcon from '../assets/img/registerIcon-grundig.png'
import GrundigBookIcon from '../assets/img/bookIcon-grundig.png'
import GrundigFavicon from '../assets/img/grundig-favicon.ico';
import ArcticLogo from '../assets/img/logo/arctic.svg';
import ArcticBoxIcon from '../assets/img/boxIcon-arctic.svg';
import ArcticRegisterIcon from '../assets/img/registerIcon-arctic.svg'
import ArcticBookIcon from '../assets/img/bookIcon-arctic.svg';
import ArcticFavicon from '../assets/img/arctic-favicon.png';
import BlombergLogo from '../assets/img/logo/blomberg-logo.svg';
import BlombergBoxIcon from '../assets/img/boxIcon-blomberg.svg';
import BlombergRegisterIcon from '../assets/img/registerIcon-blomberg.svg';
import BlombergBookIcon from '../assets/img/bookIcon-blomberg.svg';
import BlombergFavicon from '../assets/img/blomberg-favicon.ico';
import ElektrabregenzLogo from '../assets/img/logo/elektrobregen.svg';
import ElektrabregenzBoxIcon from '../assets/img/boxIcon-elektrabregenz.svg';
import ElektrabregenzRegisterIcon from '../assets/img/registerIcon-elektrabregenz.svg';
import ElektrabregenzBookIcon from '../assets/img/bookIcon-elektrabregenz.svg';
import ElektrabregenzFavicon from '../assets/img/elektrabregenz_favicon.png';
import DefyLogo from '../assets/img/logo/defy.svg';
import DefyBoxIcon from '../assets/img/boxIcon-defy.svg';
import DefyRegisterIcon from '../assets/img/registerIcon-defy.svg';
import DefyBookIcon from '../assets/img/bookIcon-defy.svg';
import DefyFavicon from '../assets/img/defy-favicon.ico';
import HitachiLogo from '../assets/img/logo/hitachi-logo.svg';
import HitachiBoxIcon from '../assets/img/boxIcon-hitachi.svg';
import HitachiRegisterIcon from '../assets/img/registerIcon-hitachi.svg';
import HitachiBookIcon from '../assets/img/bookIcon-hitachi.svg';
import HitachiFavicon from '../assets/img/hitachi-favicon.ico';
import HotpointLogo from '../assets/img/hotpoint_logo.png';
import WhirlpoolLogo from '../assets/img/whirlpool_logo.png';
import BauknechtLogo from '../assets/img/bauknecht_logo.png';

export const THEMES = {
    BEKO: 'BEKO',
    ALTUS: 'ALTUS',
    ARCELIK: 'ARÇELİK',
    GRUNDIG: 'GRUNDIG',
    ARCTIC: 'ARCTIC',
    BLOMBERG: 'BLOMBERG',
    ELEKTRABREGENZ: 'ELEKTRABREGENZ',
    DEFY: 'DEFY',
    HITACHI: 'HITACHI',
    HOTPOINT: 'HOTPOINT',
    INDESIT: 'INDESIT',
    WHIRLPOOL: 'WHIRLPOOL',
    BAUKNECHT: 'BAUKNECHT',
    DEFAULT: 'DEFAULT'

}

export const themeConfigs = [
    {
        id: THEMES.BEKO,
        name: THEMES.BEKO,
        colors: {
            mainColor: '#0096D7',
            background: "#0096D7",
            cardText: '#0a2033',
            text: "#1c4167",
            button: {
                background: "#0096d7",
                text: "#fff",
                borderRadius: "3.6rem"
            },
            serviceContentBackground: '#f2f9fd',
            footer: '#F0F0F0',
            footerText: '#222222',
            tRow: '#F2F9FD',
            headerBorder: '4px solid #51a8e6',
            loaderColor: '#0096D7'
        },
        iconPaths: {
            boxIcon: BekoBoxIcon,
            bookIcon: BekoBookIcon,
            registerIcon: BekoRegisterIcon
        },
        fonts: {
            mainText: '"Encode Sans", sans-serif',
            subText: '"Encode Sans", sans-serif'
        },
        font: '"Encode Sans", sans-serif',
        logoPath: BekoLogo,
        logoContent: '4rem',
        favicon: BekoFavicon
    },
    {
        id: THEMES.ARCELIK,
        name: THEMES.ARCELIK,
        colors: {
            mainColor: '#D93131',
            background: "#D93131",
            cardText: '#222222',
            text: "#222222",
            button: {
                background: "#FFFFFF",
                text: "#000000",
                borderRadius: ".4rem"
            },
            serviceContentBackground: '#ECE3E9',
            footer: '#1C1C1C',
            tRow: '#F6F6F6',
            headerBorder: '4px solid #D93131',
            loaderColor: '#D93131'
        },
        iconPaths: {
            boxIcon: ArcelikBoxIcon,
            bookIcon: ArcelikBookIcon,
            registerIcon: ArcelikRegisterIcon
        },
        fonts: {
            mainText: '"Roboto" , sans-serif',
            subText: '"Roboto" , sans-serif'
        },
        font: '"Roboto", sans-serif',
        logoPath: ArcelikLogo,
        logoContent: '25px',
        favicon: ArcelikFavicon
    },
    {
        id: THEMES.DEFAULT,
        name: THEMES.DEFAULT,
        colors: {
            mainColor: '#D93131',
            background: "#D93131",
            cardText: '#222222',
            text: "#222222",
            button: {
                background: "#FFFFFF",
                text: "#000000",
                borderRadius: ".4rem"
            },
            serviceContentBackground: '#ECE3E9',
            footer: '#1C1C1C',
            tRow: '#F6F6F6',
            headerBorder: '4px solid #D93131',
            loaderColor: '#D93131'
        },
        iconPaths: {
            boxIcon: ArcelikBoxIcon,
            bookIcon: ArcelikBookIcon,
            registerIcon: ArcelikRegisterIcon
        },
        fonts: {
            mainText: '"Roboto" , sans-serif',
            subText: '"Roboto" , sans-serif'
        },
        font: '"Roboto", sans-serif',
        logoPath: ArcelikGlobalLogo,
        logoContent: '25px',
        favicon: ArcelikGlobalFavicon
    },
    {
        id: THEMES.ALTUS,
        name: THEMES.ALTUS,
        colors: {
            mainColor: '#EC008C',
            background: "#EC008C",
            cardText: '#333333',
            text: "#333333",
            button: {
                background: "#EC008C",
                text: "#000000",
                borderRadius: ".4rem"
            },
            serviceContentBackground: '#F6F6F6',
            footer: '#656565',
            tRow: '#F6F6F6',
            headerBorder: '4px solid #EC008C',
            loaderColor: '#EC008C'
        },
        iconPaths: {
            boxIcon: AltusBoxIcon,
            bookIcon: AltusBookIcon,
            registerIcon: AltusRegisterIcon
        },
        fonts: {
            mainText: '"Roboto" , sans-serif',
            subText: '"Roboto" , sans-serif'
        },
        font: '"Roboto", sans-serif',
        logoPath: AltusLogo,
        logoContent: 'auto',
        favicon: AltusFavicon
    },
    {
        id: THEMES.GRUNDIG,
        name: THEMES.GRUNDIG,
        colors: {
            mainColor: '#BB442A',
            background: "#BB442A",
            cardText: '#333333',
            text: "#333333",
            button: {
                background: "#BB442A",
                text: "#000000",
                borderRadius: ".4rem"
            },
            serviceContentBackground: '#F6F6F6',
            footer: '#E9DFD0',
            footerText: '',
            tRow: '#EEEDE9',
            headerBorder: '4px solid #BB442A',
            loaderColor: '#BB442A'
        },
        iconPaths: {
            boxIcon: GrundigBoxIcon,
            bookIcon: GrundigBookIcon,
            registerIcon: GrundigRegisterIcon
        },
        fonts: {
            mainText: '"Grundig Basics" , sans-serif',
            subText: '"Grundig Basics" , sans-serif'
        },
        font: "Grundig Basics",
        logoPath: GrundigLogo,
        logoContent: 'auto',
        favicon: GrundigFavicon
    },
    {
        id: THEMES.ARCTIC,
        name: THEMES.ARCTIC,
        colors: {
            mainColor: '#97005E',
            background: '#97005E',
            cardText: '#2E3242',
            text: "#2E3242",
            button: {
                background: "#97005E",
                text: "#fff",
                borderRadius: "8px"
            },
            serviceContentBackground: '#F4F4F4',
            footer: '#FFFFFF',
            footerText: '#2E3242',
            tRow: '#F4F4F4',
            headerBorder: '4px solid #97005E',
            loaderColor: '#97005E'
        },
        iconPaths: {
            boxIcon: ArcticBoxIcon,
            bookIcon: ArcticBookIcon,
            registerIcon: ArcticRegisterIcon
        },
        fonts: {
            mainText: '"Roboto" , sans-serif',
            subText: '"Roboto" , sans-serif'
        },
        font: '"Roboto", sans-serif',
        logoPath: ArcticLogo,
        logoContent: 'auto',
        favicon: ArcticFavicon
    },
    {
        id: THEMES.BLOMBERG,
        name: THEMES.BLOMBERG,
        colors: {
            mainColor: '#C8102E',
            background: '#C8102E',
            cardText: '#14243A',
            text: "#000",
            button: {
                background: "#C8102E",
                text: "#fff",
                borderRadius: "4px"
            },
            serviceContentBackground: '#F4F4F4',
            footer: '#F0F0F0',
            footerText: '#000000',
            tRow: '#F4F4F4',
            headerBorder: '4px solid #C8102E',
            loaderColor: '#C8102E'
        },
        iconPaths: {
            boxIcon: BlombergBoxIcon,
            bookIcon: BlombergBookIcon,
            registerIcon: BlombergRegisterIcon
        },
        fonts: {
            mainText: '"Inter Tight" , sans-serif',
            subText: '"Inter Tight" , sans-serif'
        },
        font: '"Inter Tight", sans-serif',
        logoPath: BlombergLogo,
        logoContent: 'auto',
        favicon: BlombergFavicon
    },
    {
        id: THEMES.ELEKTRABREGENZ,
        name: THEMES.ELEKTRABREGENZ,
        colors: {
            mainColor: '#CC0000',
            background: '#CC0000',
            cardText: '#14243A',
            text: "#000",
            button: {
                background: "#CC0000",
                text: "#fff",
                borderRadius: "80px"
            },
            serviceContentBackground: '#F4F4F4',
            footer: '#FFFFFF',
            footerText: '#000000',
            tRow: '#F4F4F4',
            headerBorder: '4px solid #CC0000',
            loaderColor: '#CC0000'
        },
        iconPaths: {
            boxIcon: ElektrabregenzBoxIcon,
            bookIcon: ElektrabregenzBookIcon,
            registerIcon: ElektrabregenzRegisterIcon
        },
        fonts: {
            mainText: '"Poppins" , sans-serif',
            subText: '"Poppins" , sans-serif'
        },
        font: '"Poppins", sans-serif',
        logoPath: ElektrabregenzLogo,
        logoContent: '20px',
        favicon: ElektrabregenzFavicon
    },
    {
        id: THEMES.DEFY,
        name: THEMES.DEFY,
        colors: {
            mainColor: '#cd1f3d',
            background: '#cd1f3d',
            cardText: '#14243A',
            text: "#000",
            button: {
                background: "#cd1f3d",
                text: "#fff",
                borderRadius: "80px"
            },
            serviceContentBackground: '#F4F4F4',
            footer: '#F2F2F2',
            footerText: '#000000',
            tRow: '#F4F4F4',
            headerBorder: '4px solid #cd1f3d',
            loaderColor: '#cd1f3d'
        },
        iconPaths: {
            boxIcon: DefyBoxIcon,
            bookIcon: DefyBookIcon,
            registerIcon: DefyRegisterIcon
        },
        fonts: {
            mainText: '"Roboto" , sans-serif',
            subText: '"Roboto" , sans-serif'
        },
        font: '"Roboto" , sans-serif',
        logoPath: DefyLogo,
        logoContent: 'auto',
        favicon: DefyFavicon
    },
    {
        id: THEMES.HITACHI,
        name: THEMES.HITACHI,
        colors: {
            mainColor: '#A2201C',
            background: '#A2201C',
            cardText: '#14243A',
            text: "#000",
            button: {
                background: "#A2201C",
                text: "#fff",
                borderRadius: "12px"
            },
            serviceContentBackground: '#E4E5E6',
            footer: '#FFFFFF',
            footerText: '#000000',
            tRow: '#F4F4F4',
            headerBorder: '4px solid #A2201C',
            loaderColor: '#A2201C'
        },
        iconPaths: {
            boxIcon: HitachiBoxIcon,
            bookIcon: HitachiBookIcon,
            registerIcon: HitachiRegisterIcon
        },
        fonts: {
            mainText: '"Roboto" , sans-serif',
            subText: '"Roboto" , sans-serif'
        },
        font: '"Roboto", sans-serif',
        logoPath: HitachiLogo,
        logoContent: '20px',
        favicon: HitachiFavicon
    },
    {
        id: THEMES.WHIRLPOOL,
        name: THEMES.WHIRLPOOL,
        colors: {
            mainColor: "#EEB111",
            background: "#EEB111",
            cardText: "#0a2033",
            text: "#1c4167",
            tab: {
                text: "#000000",
                activeText: "#EEB111",
                activeBackground: "#EDE9E7",
                activeBorderColor: "transparent",
                borderColor: "transparent",
                downloadIconBorderColor: "#E2E2E2",
            },
            button: {
                background: "#EEB111",
                text: "#fff",
                borderRadius: "3.6rem",
            },
            serviceContentBackground: "#f2f9fd",
            footer: "#F0F0F0",
            footerText: "#222222",
            tRow: "#F2F9FD",
            headerBorder: "4px solid #51a8e6",
            loaderColor: "#EEB111",
        },
        iconPaths: {
            boxIcon: BekoBoxIcon,
            bookIcon: BekoBookIcon,
            registerIcon: BekoRegisterIcon,
        },
        fonts: {
            mainText: '"Roboto", sans-serif',
            subText: '"Roboto", sans-serif',
        },
        font: '"Roboto", sans-serif',
        logoPath: WhirlpoolLogo,
        logoContent: "4rem",
        favicon: WhirlpoolLogo,
    },
    {
        id: THEMES.HOTPOINT,
        name: THEMES.HOTPOINT,
        colors: {
            mainColor: "#DA7C43",
            background: "#DA7C43",
            cardText: "#0a2033",
            text: "#1c4167",
            tab: {
                text: "#000000",
                activeText: "#DA7C43",
                activeBackground: "#EDE9E7",
                borderColor: "transparent",
                downloadIconBorderColor: "#8F7A62",
            },
            button: {
                background: "#DA7C43",
                text: "#fff",
                borderRadius: "3.6rem",
            },
            serviceContentBackground: "#f2f9fd",
            footer: "#F0F0F0",
            footerText: "#222222",
            tRow: "#F2F9FD",
            headerBorder: "4px solid #DA7C43",
            loaderColor: "#DA7C43",
        },
        iconPaths: {
            boxIcon: BekoBoxIcon,
            bookIcon: BekoBookIcon,
            registerIcon: BekoRegisterIcon,
        },
        fonts: {
            mainText: '"Quicksand", sans-serif',
            subText: '"Quicksand", sans-serif',
        },
        font: '"Quicksand", sans-serif',
        logoPath: HotpointLogo,
        logoContent: "4rem",
        favicon: HotpointLogo,
    },
    {
        id: THEMES.INDESIT,
        name: THEMES.INDESIT,
        colors: {
            mainColor: "#0096D7",
            background: "#0096D7",
            cardText: "#0a2033",
            tabText: "#0180C9",
            text: "#1c4167",
            tab: {
                text: "#0096D7",
                activeBackground: "#CAE3F2",
                borderColor: "#0096D7",
                downloadIconBorderColor: "#E2E2E2",
            },
            button: {
                background: "#0096d7",
                text: "#fff",
                borderRadius: "3.6rem",
            },
            serviceContentBackground: "#f2f9fd",
            footer: "#F1F1F2",
            footerText: "#1A1919",
            footerWeight: "700",
            tRow: "#F2F9FD",
            headerBorder: "4px solid #51a8e6",
            loaderColor: "#0096D7",
        },
        iconPaths: {
            boxIcon: BekoBoxIcon,
            bookIcon: BekoBookIcon,
            registerIcon: BekoRegisterIcon,
        },
        fonts: {
            mainText: '"Roboto", sans-serif',
            subText: '"Roboto", sans-serif',
        },
        font: '"Roboto", sans-serif',
        logoPath: BekoLogo,
        logoContent: "4rem",
        favicon: BekoFavicon,
    },
    {
        id: THEMES.BAUKNECHT,
        name: THEMES.BAUKNECHT,
        colors: {
            mainColor: '#007D69',
            background: '#007D69',
            cardText: '#0a2033',
            text: '#1c4167',
            tab: {
                text: '#000000',
                activeText: '#000000',
                activeBackground: '#F2F2F2',
                borderColor: 'transparent',
                downloadIconBorderColor: '#E2E2E2',
            },
            button: {
                background: '#007D69',
                text: '#fff',
                borderRadius: '3.6rem',
            },
            serviceContentBackground: '#f2f9fd',
            footer: '#F0F0F0',
            footerText: '#222222',
            tRow: '#F2F9FD',
            headerBorder: '4px solid #007D69',
            loaderColor: '#000000',
        },
        iconPaths: {
            boxIcon: BekoBoxIcon,
            bookIcon: BekoBookIcon,
            registerIcon: BekoRegisterIcon,
        },
        fonts: {
            mainText: '"Roboto", sans-serif',
            subText: '"Roboto", sans-serif',
        },
        font: '"Roboto", sans-serif',
        logoPath: BauknechtLogo,
        logoContent: '4rem',
        favicon: BekoFavicon,
    },
]